import { render } from "./WinnerAnimation.vue?vue&type=template&id=0818959a&scoped=true&ts=true"
import script from "./WinnerAnimation.vue?vue&type=script&lang=ts"
export * from "./WinnerAnimation.vue?vue&type=script&lang=ts"

import "./WinnerAnimation.vue?vue&type=style&index=0&id=0818959a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0818959a"]])

export default __exports__